import { addImposterToUrl } from 'Utils';
import { api } from './axios';

const baseURL = '/MedicalReferrals';

export interface IMedicalReferral {
  id?: number;
  openDate: Date;
  part: string;
  hasFile: boolean;
  requestNumber: number;
  statusCode: number;
  updateRowDate?: Date;
  supplierName: string;
  validFromDate: Date;
  validToDate: Date;
  isActive: boolean;
  invalidationDate?: Date;
  linkedApplyNumbers: string[];
}

interface IFileRequest {
  contentType?: string;
  fileContentBase64?: string;
  documentName?: string;
}

export const getMedicalReferrals = async (count?: number) => {
  const medicalReferrals = await api.get<IMedicalReferral[]>(
    addImposterToUrl(`${baseURL}${count ? '?count=' + count : ''}`, !count)
  );
  if (medicalReferrals.data) return medicalReferrals.data;
};

export const requestFile = async (RequestNumber: number) => {
  const fileResult = await api.get<IFileRequest>(
    addImposterToUrl(`${baseURL}/${RequestNumber}/file`, true)
  );
  if (fileResult.data) return fileResult.data;
};
